import axios from 'axios';
import { allTicket, getErrorTypeList, getOrderList, raiseATicket, respondTicket } from './endpointUrl';
import { headers } from './auth-header';

// Get All Ticket
export const getAllTicketService = async () => {
  const response = await axios.get(allTicket, { headers: headers });
  return response.data;
};

// Get Order List
export const getOrderListService = async () => {
  const response = await axios.get(getOrderList, { headers: headers });
  return response.data;
};

// Get Error List
export const getErrorListService = async () => {
  const response = await axios.get(getErrorTypeList, { headers: headers });
  return response.data;
};

export const raiseATicketService = async (data: FormData) => {
  const response = await axios.post(raiseATicket, data, { headers: {Authorization: `Bearer ${localStorage.getItem("access_token")}` }});
  return response.data;
};

export const respondTicketService = async (data: any) => {
  const response = await axios.post(respondTicket, data, { headers: headers });
  return response.data;
};